var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepTypeCommand = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7 11 2-2-2-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11 13h4"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  x: 3,
  y: 3,
  rx: 2,
  ry: 2
})));
export default SvgStepTypeCommand;